var _mask, _path, _path2, _mask2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsNotFound = function SvgNotificationsNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "notifications_not_found_svg__a",
    width: 18,
    height: 11,
    x: 31.5,
    y: 60.334,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.5 60.334h18v11h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.833 62.667a6.667 6.667 0 1 1-13.333 0h13.333Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    d: "M46.833 62.667a6.667 6.667 0 1 1-13.333 0h13.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    strokeWidth: 4,
    d: "M46.833 62.667a6.667 6.667 0 1 1-13.333 0h13.333Z",
    mask: "url(#notifications_not_found_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "notifications_not_found_svg__b",
    width: 46,
    height: 48,
    x: 17.5,
    y: 11.334,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.5 11.334h46v48h-46z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m56.805 49.38 3.005 3c1.468 1.465.443 3.977-1.654 3.977H22.821c-2.073 0-3.098-2.512-1.63-3.977l3.004-3V35.426c0-7.79 5.497-14.302 12.812-15.883v-2.721c0-1.93 1.56-3.488 3.493-3.488a3.486 3.486 0 0 1 3.494 3.488v2.72c7.314 1.582 12.811 8.094 12.811 15.884V49.38Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    fillRule: "evenodd",
    d: "m56.805 49.38 3.005 3c1.468 1.465.443 3.977-1.654 3.977H22.821c-2.073 0-3.098-2.512-1.63-3.977l3.004-3V35.426c0-7.79 5.497-14.302 12.812-15.883v-2.721c0-1.93 1.56-3.488 3.493-3.488a3.486 3.486 0 0 1 3.494 3.488v2.72c7.314 1.582 12.811 8.094 12.811 15.884V49.38Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "m59.81 52.38-1.413 1.415 1.413-1.415Zm-3.005-3h-2v.83l.587.585 1.413-1.415Zm-35.614 3 1.413 1.415-1.413-1.415Zm3.004-3 1.413 1.415.587-.586v-.829h-2Zm12.812-29.837.422 1.955 1.578-.341v-1.614h-2Zm6.987 0h-2v1.614l1.578.34.422-1.954Zm17.23 31.422-3.005-3-2.827 2.83 3.005 3 2.826-2.83Zm-3.068 7.392c3.885 0 5.792-4.672 3.067-7.392l-2.826 2.83c.073.073.092.13.099.17a.348.348 0 0 1-.025.19.342.342 0 0 1-.115.15.326.326 0 0 1-.2.052v4Zm-35.335 0h35.335v-4H22.821v4Zm-3.044-7.392c-2.71 2.705-.838 7.392 3.044 7.392v-4a.29.29 0 0 1-.18-.047.34.34 0 0 1-.112-.15.356.356 0 0 1-.025-.193.312.312 0 0 1 .1-.172l-2.826-2.83Zm3.005-3-3.005 3 2.827 2.83 3.005-3-2.827-2.83Zm-.587-12.539V49.38h4V35.426h-4Zm14.389-17.838c-8.213 1.776-14.389 9.084-14.389 17.838h4c0-6.827 4.82-12.541 11.234-13.928l-.845-3.91Zm-1.578-.766v2.72h4v-2.72h-4Zm5.494-5.488a5.486 5.486 0 0 0-5.493 5.488h4c0-.823.662-1.488 1.493-1.488v-4Zm5.494 5.488a5.486 5.486 0 0 0-5.494-5.488v4c.832 0 1.494.665 1.494 1.488h4Zm0 2.72v-2.72h-4v2.72h4Zm12.811 15.884c0-8.754-6.175-16.062-14.388-17.838l-.845 3.91c6.415 1.387 11.233 7.101 11.233 13.928h4Zm0 13.954V35.426h-4V49.38h4Z",
    mask: "url(#notifications_not_found_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "notifications_not_found_svg__c",
    width: 41,
    height: 44,
    x: 20,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    fillRule: "evenodd",
    d: "m56.805 49.38 3.005 3c1.468 1.465.443 3.977-1.654 3.977H22.821c-2.073 0-3.098-2.512-1.63-3.977l3.004-3V35.426c0-7.79 5.497-14.302 12.812-15.883v-2.721c0-1.93 1.56-3.488 3.493-3.488a3.486 3.486 0 0 1 3.494 3.488v2.72c7.314 1.582 12.811 8.094 12.811 15.884V49.38Z",
    clipRule: "evenodd"
  }))));
};
export default SvgNotificationsNotFound;